export const UniqueProductFieldEnum = {
    SKU: 'sku',
    SOURCE_ID: 'source_id'
} as const;

export type UniqueProductField = typeof UniqueProductFieldEnum[keyof typeof UniqueProductFieldEnum];
